import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useKeycloak } from 'keycloak-react-web';
import { hasStaffSignal } from '../../app/roles';
import { resetFavourites, syncFavourites } from './favouritesSlice';

// Temporary retirement cleanup: never read or import the old browser-only pins.
export const clearLegacyPins = () => {
  try {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith('parkit-pinned-pages:'))
      .forEach((key) => window.localStorage.removeItem(key));
  } catch {
    // Storage restrictions must not prevent server-backed favourites from working.
  }
};

// Called once from App. Readers must not fetch or reset the shared list on mount.
export const useFavouritesSync = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const owner = keycloak?.authenticated && hasStaffSignal(keycloak) ? keycloak.tokenParsed?.sub : null;
  useEffect(() => { clearLegacyPins(); }, []);
  useEffect(() => {
    dispatch(resetFavourites());
    if (owner) dispatch(syncFavourites({ owner }));
    return () => { dispatch(resetFavourites()); };
  }, [dispatch, owner]);
};
